<div (click)="startVoipCall()">
  <i class="fas fa-phone" aria-hidden="true"></i>
  {{'button.start-voip-call' | translate}}
</div>